var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[2]!../../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[0].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[4]!./inlineEditor.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};